module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-1@3x-cee6184e7c88e6079169523e07915084.webp";